import { render, staticRenderFns } from "./course_comment.vue?vue&type=template&id=ca3c0290&scoped=true"
import script from "./course_comment.vue?vue&type=script&lang=js"
export * from "./course_comment.vue?vue&type=script&lang=js"
import style0 from "./course_comment.vue?vue&type=style&index=0&id=ca3c0290&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3c0290",
  null
  
)

export default component.exports